const sha1 = require('sha1') // eslint-disable-line @typescript-eslint/no-var-requires

const headers = (username: string, password: string) => {
  const pass = btoa(`${username}:${sha1(password)}`)
  const h = new Headers()
  h.append('Authorization', `Basic ${pass}`)

  return h
}

const body = () => {
  const fd = new FormData()
  fd.append('grant_type', 'client_credentials')
  fd.append('from_website', '1')
  return fd
}

const authorize = (api: GlobalFetch) => async (
  username: string,
  password: string,
): Promise<IAuthorizationPass> => {
  const response = await api.fetch('/api/v2/authorize', {
    body: body(),
    headers: headers(username, password),
    method: 'POST',
  })

  const responseBody:
    | IAuthorizationPass
    | IAuthorizationFail = await response.json()
  if ('error' in responseBody) {
    throw new Error(responseBody.error_description)
  }

  if ('messages' in responseBody && responseBody.messages.length > 0) {
    throw new Error(responseBody.messages[0])
  }

  return responseBody as IAuthorizationPass
}

export default authorize

export interface IAuthorizationPass {
  access_token?: string
  expires_in?: number
  token_type?: string
  id_worker?: number
}

export interface IAuthorizationFail {
  error?: string
  error_description?: string
  messages?: string[]
}
